require('./bootstrap');

// Sweet Alert 2
import Swal from 'sweetalert2'
window.Swal = Swal;
